import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import ServiceAnnouncement, { STORAGE_KEY } from './serviceAnnouncement.component';
import { connect } from 'react-redux';

import { announcementsSelector } from './store/selectors';

const ServiceAnnouncementsContainer = ({
  announcements,
}) => {
  const [hiddenAnnouncements, setHiddenAnnouncements] = useState(
    window.localStorage.getItem(STORAGE_KEY) || ''
  );

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, hiddenAnnouncements);
  }, [hiddenAnnouncements]);

  const closeAnnouncement = useCallback(id => {
    setHiddenAnnouncements(`${hiddenAnnouncements};${id}`);
  }, [hiddenAnnouncements]);

  const hiddenAnnouncementsSet = new Set(hiddenAnnouncements.split(';'));

  const renderedAnnouncements = announcements
    .filter(
      ({ communicationId }) => !hiddenAnnouncementsSet.has(String(communicationId))
    )
    .map(
      message => <ServiceAnnouncement
        message={message}
        closeAnnouncement={closeAnnouncement}
        key={message.communicationId}
      />
    );

  return (
    <>
      {renderedAnnouncements}
    </>
  );
};

ServiceAnnouncementsContainer.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = state => ({
  announcements: announcementsSelector(state),
});

export default connect(mapStateToProps)(ServiceAnnouncementsContainer);
